/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BackupDataPayload } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { RestoreResponse } from '../models';
/**
 * RestoreApi - axios parameter creator
 * @export
 */
export const RestoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Receive a single chunk of backup data from primary server and add to processing queue  **LEGACY ENDPOINT:** Use /chunk-batch for new Chunk-First Architecture  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Queued status
         * @summary Receive and queue backup data chunk (Legacy - Single Agent)
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveBackupChunk: async (requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('receiveBackupChunk', 'requestBody', requestBody)
            const localVarPath = `/api/v1/restore/chunk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Receive a single chunk of backup data from primary server and add to processing queue  **LEGACY ENDPOINT:** Use /chunk-batch for new Chunk-First Architecture  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Queued status
         * @summary Receive and queue backup data chunk (Legacy - Single Agent)
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveBackupChunk_1: async (requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('receiveBackupChunk_1', 'requestBody', requestBody)
            const localVarPath = `/api/v1/restore/chunk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Receive and process agent data for one chunk type UPDATED for Agent-First Architecture  In Agent-First: Each request typically contains ONE agent\'s data for one chunk type. For agents with large datasets, data is sent in sub-batches with record-level pagination.  **Request Payload:** ```json {     \"backup_session_id\": \"uuid\",     \"source_server_id\": \"uuid\", // Source server identifier     \"chunk_type\": \"metadata\",     \"batch_number\": 1,          // Agent number (1, 2, 3...)     \"total_batches\": 5,         // Total agents in session     \"agents_data\": [         {             \"agent_id\": \"agent-101\",             \"organization\": {...},             \"agent\": {...},             \"config_settings\": {...}         }     ],     \"timestamp\": \"2026-01-12T...\",     \"is_sub_batch\": false,      // Optional: true if record pagination     \"sub_batch_number\": 1       // Optional: sub-batch number (1, 2, 3...) } ```  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Processing status and counts
         * @summary Receive agent data for one chunk type (Agent-First Architecture)
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveChunkBatch: async (requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('receiveChunkBatch', 'requestBody', requestBody)
            const localVarPath = `/api/v1/restore/chunk-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Receive and process agent data for one chunk type UPDATED for Agent-First Architecture  In Agent-First: Each request typically contains ONE agent\'s data for one chunk type. For agents with large datasets, data is sent in sub-batches with record-level pagination.  **Request Payload:** ```json {     \"backup_session_id\": \"uuid\",     \"source_server_id\": \"uuid\", // Source server identifier     \"chunk_type\": \"metadata\",     \"batch_number\": 1,          // Agent number (1, 2, 3...)     \"total_batches\": 5,         // Total agents in session     \"agents_data\": [         {             \"agent_id\": \"agent-101\",             \"organization\": {...},             \"agent\": {...},             \"config_settings\": {...}         }     ],     \"timestamp\": \"2026-01-12T...\",     \"is_sub_batch\": false,      // Optional: true if record pagination     \"sub_batch_number\": 1       // Optional: sub-batch number (1, 2, 3...) } ```  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Processing status and counts
         * @summary Receive agent data for one chunk type (Agent-First Architecture)
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveChunkBatch_2: async (requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('receiveChunkBatch_2', 'requestBody', requestBody)
            const localVarPath = `/api/v1/restore/chunk-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restore complete backup data from primary server  **This endpoint receives backup data and:** 1. Creates/updates organization 2. Creates/updates agent 3. Restores all contexts 4. Restores all customer data (dynamic context) 5. Restores all vendor APIs 6. Restores all unanswered questions 7. Restores all transfer cases 8. Restores all environment variables 9. **IMPORTANT**: Sets config settings with backup PAT/OrgId as PRIMARY  **Authentication:** - Optional: Add authentication header check - Example: X-Backup-Secret header validation  **Returns:** - Restoration summary with counts
         * @summary Restore backup data to this server
         * @param {BackupDataPayload} backupDataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackupData: async (backupDataPayload: BackupDataPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backupDataPayload' is not null or undefined
            assertParamExists('restoreBackupData', 'backupDataPayload', backupDataPayload)
            const localVarPath = `/api/v1/restore/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backupDataPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restore complete backup data from primary server  **This endpoint receives backup data and:** 1. Creates/updates organization 2. Creates/updates agent 3. Restores all contexts 4. Restores all customer data (dynamic context) 5. Restores all vendor APIs 6. Restores all unanswered questions 7. Restores all transfer cases 8. Restores all environment variables 9. **IMPORTANT**: Sets config settings with backup PAT/OrgId as PRIMARY  **Authentication:** - Optional: Add authentication header check - Example: X-Backup-Secret header validation  **Returns:** - Restoration summary with counts
         * @summary Restore backup data to this server
         * @param {BackupDataPayload} backupDataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackupData_3: async (backupDataPayload: BackupDataPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backupDataPayload' is not null or undefined
            assertParamExists('restoreBackupData_3', 'backupDataPayload', backupDataPayload)
            const localVarPath = `/api/v1/restore/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backupDataPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check endpoint for restore service  **Returns:** - status: \"healthy\" - message: Restore service details
         * @summary Check if restore service is available
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/restore/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check endpoint for restore service  **Returns:** - status: \"healthy\" - message: Restore service details
         * @summary Check if restore service is available
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreHealthCheck_4: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/restore/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate backup data structure without actually restoring  **Useful for:** - Testing backup data before restoration - Checking data integrity - Previewing what will be restored  **Returns:** - Validation results - Data counts - Any warnings or issues
         * @summary Validate backup data without restoring
         * @param {BackupDataPayload} backupDataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBackupData: async (backupDataPayload: BackupDataPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backupDataPayload' is not null or undefined
            assertParamExists('validateBackupData', 'backupDataPayload', backupDataPayload)
            const localVarPath = `/api/v1/restore/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backupDataPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate backup data structure without actually restoring  **Useful for:** - Testing backup data before restoration - Checking data integrity - Previewing what will be restored  **Returns:** - Validation results - Data counts - Any warnings or issues
         * @summary Validate backup data without restoring
         * @param {BackupDataPayload} backupDataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBackupData_5: async (backupDataPayload: BackupDataPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backupDataPayload' is not null or undefined
            assertParamExists('validateBackupData_5', 'backupDataPayload', backupDataPayload)
            const localVarPath = `/api/v1/restore/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backupDataPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestoreApi - functional programming interface
 * @export
 */
export const RestoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestoreApiAxiosParamCreator(configuration)
    return {
        /**
         * Receive a single chunk of backup data from primary server and add to processing queue  **LEGACY ENDPOINT:** Use /chunk-batch for new Chunk-First Architecture  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Queued status
         * @summary Receive and queue backup data chunk (Legacy - Single Agent)
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveBackupChunk(requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveBackupChunk(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.receiveBackupChunk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Receive a single chunk of backup data from primary server and add to processing queue  **LEGACY ENDPOINT:** Use /chunk-batch for new Chunk-First Architecture  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Queued status
         * @summary Receive and queue backup data chunk (Legacy - Single Agent)
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveBackupChunk_1(requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveBackupChunk_1(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.receiveBackupChunk_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Receive and process agent data for one chunk type UPDATED for Agent-First Architecture  In Agent-First: Each request typically contains ONE agent\'s data for one chunk type. For agents with large datasets, data is sent in sub-batches with record-level pagination.  **Request Payload:** ```json {     \"backup_session_id\": \"uuid\",     \"source_server_id\": \"uuid\", // Source server identifier     \"chunk_type\": \"metadata\",     \"batch_number\": 1,          // Agent number (1, 2, 3...)     \"total_batches\": 5,         // Total agents in session     \"agents_data\": [         {             \"agent_id\": \"agent-101\",             \"organization\": {...},             \"agent\": {...},             \"config_settings\": {...}         }     ],     \"timestamp\": \"2026-01-12T...\",     \"is_sub_batch\": false,      // Optional: true if record pagination     \"sub_batch_number\": 1       // Optional: sub-batch number (1, 2, 3...) } ```  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Processing status and counts
         * @summary Receive agent data for one chunk type (Agent-First Architecture)
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveChunkBatch(requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveChunkBatch(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.receiveChunkBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Receive and process agent data for one chunk type UPDATED for Agent-First Architecture  In Agent-First: Each request typically contains ONE agent\'s data for one chunk type. For agents with large datasets, data is sent in sub-batches with record-level pagination.  **Request Payload:** ```json {     \"backup_session_id\": \"uuid\",     \"source_server_id\": \"uuid\", // Source server identifier     \"chunk_type\": \"metadata\",     \"batch_number\": 1,          // Agent number (1, 2, 3...)     \"total_batches\": 5,         // Total agents in session     \"agents_data\": [         {             \"agent_id\": \"agent-101\",             \"organization\": {...},             \"agent\": {...},             \"config_settings\": {...}         }     ],     \"timestamp\": \"2026-01-12T...\",     \"is_sub_batch\": false,      // Optional: true if record pagination     \"sub_batch_number\": 1       // Optional: sub-batch number (1, 2, 3...) } ```  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Processing status and counts
         * @summary Receive agent data for one chunk type (Agent-First Architecture)
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveChunkBatch_2(requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveChunkBatch_2(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.receiveChunkBatch_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restore complete backup data from primary server  **This endpoint receives backup data and:** 1. Creates/updates organization 2. Creates/updates agent 3. Restores all contexts 4. Restores all customer data (dynamic context) 5. Restores all vendor APIs 6. Restores all unanswered questions 7. Restores all transfer cases 8. Restores all environment variables 9. **IMPORTANT**: Sets config settings with backup PAT/OrgId as PRIMARY  **Authentication:** - Optional: Add authentication header check - Example: X-Backup-Secret header validation  **Returns:** - Restoration summary with counts
         * @summary Restore backup data to this server
         * @param {BackupDataPayload} backupDataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreBackupData(backupDataPayload: BackupDataPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreBackupData(backupDataPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.restoreBackupData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restore complete backup data from primary server  **This endpoint receives backup data and:** 1. Creates/updates organization 2. Creates/updates agent 3. Restores all contexts 4. Restores all customer data (dynamic context) 5. Restores all vendor APIs 6. Restores all unanswered questions 7. Restores all transfer cases 8. Restores all environment variables 9. **IMPORTANT**: Sets config settings with backup PAT/OrgId as PRIMARY  **Authentication:** - Optional: Add authentication header check - Example: X-Backup-Secret header validation  **Returns:** - Restoration summary with counts
         * @summary Restore backup data to this server
         * @param {BackupDataPayload} backupDataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreBackupData_3(backupDataPayload: BackupDataPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreBackupData_3(backupDataPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.restoreBackupData_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check endpoint for restore service  **Returns:** - status: \"healthy\" - message: Restore service details
         * @summary Check if restore service is available
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.restoreHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check endpoint for restore service  **Returns:** - status: \"healthy\" - message: Restore service details
         * @summary Check if restore service is available
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreHealthCheck_4(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreHealthCheck_4(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.restoreHealthCheck_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate backup data structure without actually restoring  **Useful for:** - Testing backup data before restoration - Checking data integrity - Previewing what will be restored  **Returns:** - Validation results - Data counts - Any warnings or issues
         * @summary Validate backup data without restoring
         * @param {BackupDataPayload} backupDataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBackupData(backupDataPayload: BackupDataPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBackupData(backupDataPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.validateBackupData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate backup data structure without actually restoring  **Useful for:** - Testing backup data before restoration - Checking data integrity - Previewing what will be restored  **Returns:** - Validation results - Data counts - Any warnings or issues
         * @summary Validate backup data without restoring
         * @param {BackupDataPayload} backupDataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBackupData_5(backupDataPayload: BackupDataPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBackupData_5(backupDataPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestoreApi.validateBackupData_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestoreApi - factory interface
 * @export
 */
export const RestoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestoreApiFp(configuration)
    return {
        /**
         * Receive a single chunk of backup data from primary server and add to processing queue  **LEGACY ENDPOINT:** Use /chunk-batch for new Chunk-First Architecture  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Queued status
         * @summary Receive and queue backup data chunk (Legacy - Single Agent)
         * @param {RestoreApiReceiveBackupChunkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveBackupChunk(requestParameters: RestoreApiReceiveBackupChunkRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.receiveBackupChunk(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Receive a single chunk of backup data from primary server and add to processing queue  **LEGACY ENDPOINT:** Use /chunk-batch for new Chunk-First Architecture  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Queued status
         * @summary Receive and queue backup data chunk (Legacy - Single Agent)
         * @param {RestoreApiReceiveBackupChunk0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveBackupChunk_1(requestParameters: RestoreApiReceiveBackupChunk0Request, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.receiveBackupChunk_1(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Receive and process agent data for one chunk type UPDATED for Agent-First Architecture  In Agent-First: Each request typically contains ONE agent\'s data for one chunk type. For agents with large datasets, data is sent in sub-batches with record-level pagination.  **Request Payload:** ```json {     \"backup_session_id\": \"uuid\",     \"source_server_id\": \"uuid\", // Source server identifier     \"chunk_type\": \"metadata\",     \"batch_number\": 1,          // Agent number (1, 2, 3...)     \"total_batches\": 5,         // Total agents in session     \"agents_data\": [         {             \"agent_id\": \"agent-101\",             \"organization\": {...},             \"agent\": {...},             \"config_settings\": {...}         }     ],     \"timestamp\": \"2026-01-12T...\",     \"is_sub_batch\": false,      // Optional: true if record pagination     \"sub_batch_number\": 1       // Optional: sub-batch number (1, 2, 3...) } ```  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Processing status and counts
         * @summary Receive agent data for one chunk type (Agent-First Architecture)
         * @param {RestoreApiReceiveChunkBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveChunkBatch(requestParameters: RestoreApiReceiveChunkBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.receiveChunkBatch(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Receive and process agent data for one chunk type UPDATED for Agent-First Architecture  In Agent-First: Each request typically contains ONE agent\'s data for one chunk type. For agents with large datasets, data is sent in sub-batches with record-level pagination.  **Request Payload:** ```json {     \"backup_session_id\": \"uuid\",     \"source_server_id\": \"uuid\", // Source server identifier     \"chunk_type\": \"metadata\",     \"batch_number\": 1,          // Agent number (1, 2, 3...)     \"total_batches\": 5,         // Total agents in session     \"agents_data\": [         {             \"agent_id\": \"agent-101\",             \"organization\": {...},             \"agent\": {...},             \"config_settings\": {...}         }     ],     \"timestamp\": \"2026-01-12T...\",     \"is_sub_batch\": false,      // Optional: true if record pagination     \"sub_batch_number\": 1       // Optional: sub-batch number (1, 2, 3...) } ```  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Processing status and counts
         * @summary Receive agent data for one chunk type (Agent-First Architecture)
         * @param {RestoreApiReceiveChunkBatch0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveChunkBatch_2(requestParameters: RestoreApiReceiveChunkBatch0Request, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.receiveChunkBatch_2(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Restore complete backup data from primary server  **This endpoint receives backup data and:** 1. Creates/updates organization 2. Creates/updates agent 3. Restores all contexts 4. Restores all customer data (dynamic context) 5. Restores all vendor APIs 6. Restores all unanswered questions 7. Restores all transfer cases 8. Restores all environment variables 9. **IMPORTANT**: Sets config settings with backup PAT/OrgId as PRIMARY  **Authentication:** - Optional: Add authentication header check - Example: X-Backup-Secret header validation  **Returns:** - Restoration summary with counts
         * @summary Restore backup data to this server
         * @param {RestoreApiRestoreBackupDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackupData(requestParameters: RestoreApiRestoreBackupDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<RestoreResponse> {
            return localVarFp.restoreBackupData(requestParameters.backupDataPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Restore complete backup data from primary server  **This endpoint receives backup data and:** 1. Creates/updates organization 2. Creates/updates agent 3. Restores all contexts 4. Restores all customer data (dynamic context) 5. Restores all vendor APIs 6. Restores all unanswered questions 7. Restores all transfer cases 8. Restores all environment variables 9. **IMPORTANT**: Sets config settings with backup PAT/OrgId as PRIMARY  **Authentication:** - Optional: Add authentication header check - Example: X-Backup-Secret header validation  **Returns:** - Restoration summary with counts
         * @summary Restore backup data to this server
         * @param {RestoreApiRestoreBackupData0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackupData_3(requestParameters: RestoreApiRestoreBackupData0Request, options?: RawAxiosRequestConfig): AxiosPromise<RestoreResponse> {
            return localVarFp.restoreBackupData_3(requestParameters.backupDataPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Health check endpoint for restore service  **Returns:** - status: \"healthy\" - message: Restore service details
         * @summary Check if restore service is available
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreHealthCheck(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.restoreHealthCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * Health check endpoint for restore service  **Returns:** - status: \"healthy\" - message: Restore service details
         * @summary Check if restore service is available
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreHealthCheck_4(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.restoreHealthCheck_4(options).then((request) => request(axios, basePath));
        },
        /**
         * Validate backup data structure without actually restoring  **Useful for:** - Testing backup data before restoration - Checking data integrity - Previewing what will be restored  **Returns:** - Validation results - Data counts - Any warnings or issues
         * @summary Validate backup data without restoring
         * @param {RestoreApiValidateBackupDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBackupData(requestParameters: RestoreApiValidateBackupDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.validateBackupData(requestParameters.backupDataPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate backup data structure without actually restoring  **Useful for:** - Testing backup data before restoration - Checking data integrity - Previewing what will be restored  **Returns:** - Validation results - Data counts - Any warnings or issues
         * @summary Validate backup data without restoring
         * @param {RestoreApiValidateBackupData0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBackupData_5(requestParameters: RestoreApiValidateBackupData0Request, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.validateBackupData_5(requestParameters.backupDataPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for receiveBackupChunk operation in RestoreApi.
 * @export
 * @interface RestoreApiReceiveBackupChunkRequest
 */
export interface RestoreApiReceiveBackupChunkRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RestoreApiReceiveBackupChunk
     */
    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for receiveBackupChunk_1 operation in RestoreApi.
 * @export
 * @interface RestoreApiReceiveBackupChunk0Request
 */
export interface RestoreApiReceiveBackupChunk0Request {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RestoreApiReceiveBackupChunk0
     */
    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for receiveChunkBatch operation in RestoreApi.
 * @export
 * @interface RestoreApiReceiveChunkBatchRequest
 */
export interface RestoreApiReceiveChunkBatchRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RestoreApiReceiveChunkBatch
     */
    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for receiveChunkBatch_2 operation in RestoreApi.
 * @export
 * @interface RestoreApiReceiveChunkBatch0Request
 */
export interface RestoreApiReceiveChunkBatch0Request {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RestoreApiReceiveChunkBatch0
     */
    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for restoreBackupData operation in RestoreApi.
 * @export
 * @interface RestoreApiRestoreBackupDataRequest
 */
export interface RestoreApiRestoreBackupDataRequest {
    /**
     * 
     * @type {BackupDataPayload}
     * @memberof RestoreApiRestoreBackupData
     */
    readonly backupDataPayload: BackupDataPayload
}

/**
 * Request parameters for restoreBackupData_3 operation in RestoreApi.
 * @export
 * @interface RestoreApiRestoreBackupData0Request
 */
export interface RestoreApiRestoreBackupData0Request {
    /**
     * 
     * @type {BackupDataPayload}
     * @memberof RestoreApiRestoreBackupData0
     */
    readonly backupDataPayload: BackupDataPayload
}

/**
 * Request parameters for validateBackupData operation in RestoreApi.
 * @export
 * @interface RestoreApiValidateBackupDataRequest
 */
export interface RestoreApiValidateBackupDataRequest {
    /**
     * 
     * @type {BackupDataPayload}
     * @memberof RestoreApiValidateBackupData
     */
    readonly backupDataPayload: BackupDataPayload
}

/**
 * Request parameters for validateBackupData_5 operation in RestoreApi.
 * @export
 * @interface RestoreApiValidateBackupData0Request
 */
export interface RestoreApiValidateBackupData0Request {
    /**
     * 
     * @type {BackupDataPayload}
     * @memberof RestoreApiValidateBackupData0
     */
    readonly backupDataPayload: BackupDataPayload
}

/**
 * RestoreApi - object-oriented interface
 * @export
 * @class RestoreApi
 * @extends {BaseAPI}
 */
export class RestoreApi extends BaseAPI {
    /**
     * Receive a single chunk of backup data from primary server and add to processing queue  **LEGACY ENDPOINT:** Use /chunk-batch for new Chunk-First Architecture  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Queued status
     * @summary Receive and queue backup data chunk (Legacy - Single Agent)
     * @param {RestoreApiReceiveBackupChunkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public receiveBackupChunk(requestParameters: RestoreApiReceiveBackupChunkRequest, options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).receiveBackupChunk(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Receive a single chunk of backup data from primary server and add to processing queue  **LEGACY ENDPOINT:** Use /chunk-batch for new Chunk-First Architecture  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Queued status
     * @summary Receive and queue backup data chunk (Legacy - Single Agent)
     * @param {RestoreApiReceiveBackupChunk0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public receiveBackupChunk_1(requestParameters: RestoreApiReceiveBackupChunk0Request, options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).receiveBackupChunk_1(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Receive and process agent data for one chunk type UPDATED for Agent-First Architecture  In Agent-First: Each request typically contains ONE agent\'s data for one chunk type. For agents with large datasets, data is sent in sub-batches with record-level pagination.  **Request Payload:** ```json {     \"backup_session_id\": \"uuid\",     \"source_server_id\": \"uuid\", // Source server identifier     \"chunk_type\": \"metadata\",     \"batch_number\": 1,          // Agent number (1, 2, 3...)     \"total_batches\": 5,         // Total agents in session     \"agents_data\": [         {             \"agent_id\": \"agent-101\",             \"organization\": {...},             \"agent\": {...},             \"config_settings\": {...}         }     ],     \"timestamp\": \"2026-01-12T...\",     \"is_sub_batch\": false,      // Optional: true if record pagination     \"sub_batch_number\": 1       // Optional: sub-batch number (1, 2, 3...) } ```  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Processing status and counts
     * @summary Receive agent data for one chunk type (Agent-First Architecture)
     * @param {RestoreApiReceiveChunkBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public receiveChunkBatch(requestParameters: RestoreApiReceiveChunkBatchRequest, options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).receiveChunkBatch(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Receive and process agent data for one chunk type UPDATED for Agent-First Architecture  In Agent-First: Each request typically contains ONE agent\'s data for one chunk type. For agents with large datasets, data is sent in sub-batches with record-level pagination.  **Request Payload:** ```json {     \"backup_session_id\": \"uuid\",     \"source_server_id\": \"uuid\", // Source server identifier     \"chunk_type\": \"metadata\",     \"batch_number\": 1,          // Agent number (1, 2, 3...)     \"total_batches\": 5,         // Total agents in session     \"agents_data\": [         {             \"agent_id\": \"agent-101\",             \"organization\": {...},             \"agent\": {...},             \"config_settings\": {...}         }     ],     \"timestamp\": \"2026-01-12T...\",     \"is_sub_batch\": false,      // Optional: true if record pagination     \"sub_batch_number\": 1       // Optional: sub-batch number (1, 2, 3...) } ```  **Chunk Types:** - metadata: Organization + Agent + Config Settings - contexts: Context files - customer_data: Dynamic context data - vendor_apis: Vendor API configurations - unanswered_questions: Q&A data - transfer_cases: Chat transfer cases - environ_variables: Environment variables  **Returns:** Processing status and counts
     * @summary Receive agent data for one chunk type (Agent-First Architecture)
     * @param {RestoreApiReceiveChunkBatch0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public receiveChunkBatch_2(requestParameters: RestoreApiReceiveChunkBatch0Request, options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).receiveChunkBatch_2(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restore complete backup data from primary server  **This endpoint receives backup data and:** 1. Creates/updates organization 2. Creates/updates agent 3. Restores all contexts 4. Restores all customer data (dynamic context) 5. Restores all vendor APIs 6. Restores all unanswered questions 7. Restores all transfer cases 8. Restores all environment variables 9. **IMPORTANT**: Sets config settings with backup PAT/OrgId as PRIMARY  **Authentication:** - Optional: Add authentication header check - Example: X-Backup-Secret header validation  **Returns:** - Restoration summary with counts
     * @summary Restore backup data to this server
     * @param {RestoreApiRestoreBackupDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public restoreBackupData(requestParameters: RestoreApiRestoreBackupDataRequest, options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).restoreBackupData(requestParameters.backupDataPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restore complete backup data from primary server  **This endpoint receives backup data and:** 1. Creates/updates organization 2. Creates/updates agent 3. Restores all contexts 4. Restores all customer data (dynamic context) 5. Restores all vendor APIs 6. Restores all unanswered questions 7. Restores all transfer cases 8. Restores all environment variables 9. **IMPORTANT**: Sets config settings with backup PAT/OrgId as PRIMARY  **Authentication:** - Optional: Add authentication header check - Example: X-Backup-Secret header validation  **Returns:** - Restoration summary with counts
     * @summary Restore backup data to this server
     * @param {RestoreApiRestoreBackupData0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public restoreBackupData_3(requestParameters: RestoreApiRestoreBackupData0Request, options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).restoreBackupData_3(requestParameters.backupDataPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check endpoint for restore service  **Returns:** - status: \"healthy\" - message: Restore service details
     * @summary Check if restore service is available
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public restoreHealthCheck(options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).restoreHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check endpoint for restore service  **Returns:** - status: \"healthy\" - message: Restore service details
     * @summary Check if restore service is available
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public restoreHealthCheck_4(options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).restoreHealthCheck_4(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate backup data structure without actually restoring  **Useful for:** - Testing backup data before restoration - Checking data integrity - Previewing what will be restored  **Returns:** - Validation results - Data counts - Any warnings or issues
     * @summary Validate backup data without restoring
     * @param {RestoreApiValidateBackupDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public validateBackupData(requestParameters: RestoreApiValidateBackupDataRequest, options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).validateBackupData(requestParameters.backupDataPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate backup data structure without actually restoring  **Useful for:** - Testing backup data before restoration - Checking data integrity - Previewing what will be restored  **Returns:** - Validation results - Data counts - Any warnings or issues
     * @summary Validate backup data without restoring
     * @param {RestoreApiValidateBackupData0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestoreApi
     */
    public validateBackupData_5(requestParameters: RestoreApiValidateBackupData0Request, options?: RawAxiosRequestConfig) {
        return RestoreApiFp(this.configuration).validateBackupData_5(requestParameters.backupDataPayload, options).then((request) => request(this.axios, this.basePath));
    }
}

